<template>
  <div class="background--black">
    <div v-if="guide" class="featured-article container">
      <div class="featured-article__image">
        <img :src="guide.homePageImage" :alt="guideTitle" />
      </div>
      <div class="featured-article-content">
        <div class="featured-article__label">
          {{ $t("categories.guide").toUpperCase() }}
        </div>
        <h1 class="featured-article__title">{{ guideTitle }}</h1>
        <p class="featured-article__excerpt" v-html="guideExcerpt" />
        <div class="featured-article__links">
          <a class="featured-article__link--focus" :href="guideUrl">
            {{ $t("buttons.read-full-guide").toUpperCase() }}
          </a>
          <a class="featured-article__link" :href="guidesUrl">
            {{ $t("buttons.view-more-guides").toUpperCase() }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "ArticleGuideComponent",
  props: {
    locale: {
      type: String,
      default: "en",
    },
    country: {
      type: String,
      default: "SG",
    },
    guidesUrl: {
      type: String,
      default: "#",
    },
    cache: {
      type: Object,
      default: () => ({
        cache: true,
        component: "article_guide",
      }),
    },
  },
  apollo: {
    guide: {
      query: gql`
        query getArticles($locale: String!, $country: String!) {
          featuredArticles(
            type: "guide"
            locale: $locale
            country: $country
            limit: 1
          ) {
            image
            title
            slug
            url
            author
            excerpt
            homePageImage
            titleInCountry(country: $country)
            languageInCountry(country: $country)
            excerptInCountry(country: $country)
          }
        }
      `,
      variables() {
        return {
          country: this.country,
          locale: this.locale,
          cache: this.cache,
        };
      },
      update(data) {
        return data.featuredArticles[0];
      },
      skip() {
        // Without this skip it will sometimes cause blank Firework stories.
        return !this.country;
      },
    },
  },
  data() {
    return {
      guide: null,
    };
  },
  computed: {
    guideUrl() {
      const language = this.guide.languageInCountry;

      return `${this.guide.url}${language ? `/${language}` : ""}`;
    },

    guideTitle() {
      return this.guide.titleInCountry || this.guide.title;
    },

    guideExcerpt() {
      return this.guide.excerptInCountry || this.guide.excerpt;
    },
  },
};
</script>
